export default __webpack_public_path__ + "static/media/addIngredientss.339068e5.png";